import {useAuthenticator} from "@aws-amplify/ui-react";

/**
 * Auth state as the UI cares about it.
 *
 * "loading" matters: Amplify resolves the session asynchronously, so on first
 * render authStatus is "configuring" and `user` is undefined for a signed-in
 * member just the same as for a guest. Treating that as "guest" would flash the
 * sign-up prompt at people who are already signed in, so callers must hold off
 * on both fetching and prompting until this settles.
 *
 * Until now nothing hit this, because every authenticated page mounted inside
 * withAuthenticator, which renders its children only once auth has resolved.
 * Guest-visible pages have no such guarantee.
 */
export type AuthState = "loading" | "signedIn" | "guest"

export function useAuthState(): AuthState {
  const {authStatus} = useAuthenticator((context) => [context.authStatus])

  if (authStatus === "configuring") return "loading"
  return authStatus === "authenticated" ? "signedIn" : "guest"
}

export function useIsSignedIn(): boolean {
  return useAuthState() === "signedIn"
}
